import React, { useEffect, useState } from 'react';
import './App.css';
import { client, databaseId, roomsCollectionId, databases, settingsCollectionId } from "./components/appwrite";
import BasicCard from "./components/Card";



export type Room = {
    $id: string; // Corrected to $id
    index: number;
    displayname: string;
    number: string;
    cancelled?: boolean;
    newnumber?: string;
    notice?: string;
};

export type Settings = {
    $id: string; // Corrected to $id
    settingId: string;
    data: string;

}

const roomsSubscribeChannel = `databases.${databaseId}.collections.${roomsCollectionId}.documents`;
const settingsSubscribeChannel = `databases.${databaseId}.collections.${settingsCollectionId}.documents`;

function App() {
    const [roomdata, setRoomdata] = useState<Room[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [settings, setSettings] = useState<Settings[]>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const itemsPerPage = 10;
    const hideButtons = true;
    const [timeInterval, setTimeInterval] = useState<number>(6975);



    useEffect(() => {
        let promise = databases.listDocuments(databaseId, roomsCollectionId);
        promise.then(function (response) {
            console.log(response);
            let data = response.documents.map((document) => {
                return {
                    $id: document.$id, // Corrected to $id
                    index: document.index,
                    displayname: document.displayname,
                    number: document.number,
                    cancelled: document.cancelled,
                    newnumber: document.newnumber,
                    notice: document.notice,
                };
            });
            setRoomdata(data);
        });

        let settingsPromise = databases.listDocuments(databaseId, settingsCollectionId);
        settingsPromise.then(function (response) {
            console.log(response);
            let data = response.documents.map((document) => {
                return {
                    $id: document.$id, // Corrected to $id
                    settingId: document.settingId,
                    data: document.data,
                };
            });
            setSettings(data);
        });

        Promise.all([promise, settingsPromise]).then(() => {
            setLoading(false);
        });

    }, []);

    useEffect(() => {
        const unsubscribe = client.subscribe(roomsSubscribeChannel, (response: any) => { // Use type assertion
            if (

                response.payload &&
                response.events &&
                response.events.includes(`${roomsSubscribeChannel}.*.create`) ||
                response.events.includes(`${roomsSubscribeChannel}.*.update`) ||
                response.events.includes(`${roomsSubscribeChannel}.*.delete`)
            ) {
                console.log(response);
                // the payload contains a room, it can be a new room or an updated room. We need to check if it already exists in the roomdata array
                const room = response.payload;
                const roomIndex = roomdata.findIndex((r) => r.$id === room.$id); // Corrected to $id

                if (response.events.includes(`${roomsSubscribeChannel}.*.delete`)) {
                    // the room was deleted, we need to remove it from the roomdata array
                    setRoomdata((prevRoomdata) => prevRoomdata.filter((r) => r.$id !== room.$id)); // Corrected to $id
                } else if (roomIndex === -1) {
                    // the room does not exist in the roomdata array, we need to add it
                    setRoomdata((prevRoomdata) => [...prevRoomdata, room]);
                } else {
                    // the room exists in the roomdata array, we need to update it
                    setRoomdata((prevRoomdata) => {
                        const newRoomdata = [...prevRoomdata];
                        newRoomdata[roomIndex] = room;
                        return newRoomdata;
                    });
                }
            }
          });

        return () => {
            unsubscribe();
        }
    }, [roomdata]);


    useEffect(() => {
        const unsubscribe = client.subscribe(settingsSubscribeChannel, (response: any) => { // Use type assertion
            if (
                response.payload &&
                response.events &&
                response.events.includes(`${settingsSubscribeChannel}.*.create`) ||
                response.events.includes(`${settingsSubscribeChannel}.*.update`) ||
                response.events.includes(`${settingsSubscribeChannel}.*.delete`)
            ) {
                console.log(response);
                // the payload contains a room, it can be a new room or an updated room. We need to check if it already exists in the roomdata array
                const setting = response.payload;
                const settingIndex = settings.findIndex((s) => s.$id === setting.$id); // Corrected to $id

                if (response.events.includes(`${settingsSubscribeChannel}.*.delete`)) {
                    // the room was deleted, we need to remove it from the roomdata array
                    setSettings((prevSettings) => prevSettings.filter((s) => s.$id !== setting.$id)); // Corrected to $id
                } else if (settingIndex === -1) {
                    // the room does not exist in the roomdata array, we need to add it
                    setSettings((prevSettings) => [...prevSettings, setting]);
                } else {
                    // the room exists in the roomdata array, we need to update it
                    setSettings((prevSettings) => {
                        const newSettings = [...prevSettings];
                        newSettings[settingIndex] = setting;
                        return newSettings;
                    });
                }
            }

          });

        return () => {
            unsubscribe();
        }
    }, [settings]);


    const sortedRoomdata = roomdata.sort((a, b) => a.index - b.index);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    const roomsOnCurrentPage = sortedRoomdata.slice(startIndex, endIndex);

    const totalPages = Math.ceil(sortedRoomdata.length / itemsPerPage);








    return (
        <div className="App">
            {loading ? (
                <p>Loading...</p>
            ) : (
                <>
                    <div>
                        {roomsOnCurrentPage.map((room) => (
                            <BasicCard key={room.$id} room={room} />
                        ))}
                    </div>
                    {!hideButtons && (
                        <div>
                            {Array.from({ length: totalPages }, (_, index) => (
                                <button
                                    key={index}
                                    onClick={() => setCurrentPage(index + 1)}
                                    className={index + 1 === currentPage ? 'active' : ''}
                                >
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default App;
